import { Outlet, Navigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/store/authStore';
import { useThemeLogo } from '@/styles/themes';
import styles from './AuthLayout.module.css';

/**
 * Layout for unauthenticated pages (login, register, reset-password).
 * Redirects to dashboard if user is already authenticated.
 */
export function AuthLayout() {
  const { t } = useTranslation();
  const token = useAuthStore((s) => s.token);
  const role = useAuthStore((s) => s.role);
  const logoSrc = useThemeLogo();

  if (token) {
    const dest = role === 'employee' ? '/my/dashboard' : '/dashboard';
    return <Navigate to={dest} replace />;
  }

  return (
    <div className={styles.root}>
      <main className={styles.card}>
        <div className={styles.logoBlock}>
          <img src={logoSrc} alt="Casalary" className={styles.brandLogo} />
          <p className={styles.tagline}>Swiss household payroll</p>
        </div>
        <Outlet />
      </main>
      <footer className={styles.legalFooter}>
        <Link to="/privacy" className={styles.legalLink}>
          {t('privacy.title')}
        </Link>
      </footer>
    </div>
  );
}
